import { render, staticRenderFns } from "./classBagRecord.vue?vue&type=template&id=5bca80cd&"
import script from "./classBagRecord.vue?vue&type=script&lang=js&"
export * from "./classBagRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports